import {  createSlice } from '@reduxjs/toolkit';
import {
  deviceAdaptAPI,
  deviceAdaptStartAPI,
  deviceAdaptPreviousStepAPI,
  deviceAdaptUpdateAPI,
  deviceAdaptResourceAPI
} from '../api/adaptAPI';

const initialState = {
  adaptStartError: null,
  adaptStartSuccess: null,
};

export const adaptSlice = createSlice({
  name: 'register',
  initialState,
  reducers: {
    adaptStartError(state, action){
      state.adaptStartError = action.payload
    },
    adaptStartSuccess(state, action){
      state.data = action.payload
    },
  },
});

export const { adaptStartError, adaptStartSuccess} = adaptSlice.actions;

export const deviceAdapt =  (id, callback) => async (dispatch, getState) => {
  try{
    const response = await deviceAdaptAPI(id)
    if(response){
      dispatch(adaptStartSuccess(response))
    }
    if(callback) callback(response)
    return response;
  } catch (forgetError) {
    dispatch(adaptStartError(forgetError))
  }
};
export const deviceAdaptResource =  (callback) => async (dispatch, getState) => {
  try{
    const response = await deviceAdaptResourceAPI()
    if(response){
      dispatch(adaptStartSuccess(response))
    }
    if(callback) callback(response)
    return response;
  } catch (forgetError) {
    dispatch(adaptStartError(forgetError))
  }
};
export const deviceAdaptStart =  (data, callback) => async (dispatch, getState) => {
  try{
    const response = await deviceAdaptStartAPI(data)
    if(response){
      dispatch(adaptStartSuccess(response))
    }
    if(callback) callback(response)
    return response;
  } catch (forgetError) {
    dispatch(adaptStartError(forgetError))
  }
};
export const deviceAdaptUpdate =  (id, data, callback) => async (dispatch, getState) => {
  try{
    const response = await deviceAdaptUpdateAPI(id, data)
    if(response){
      dispatch(adaptStartSuccess(response))
    }
    if(callback) callback(response)
    return response;
  } catch (forgetError) {
    dispatch(adaptStartError(forgetError))
  }
};
export const deviceAdaptPreviousStep =  (id, adaptId, callback) => async (dispatch, getState) => {
  try{
    const response = await deviceAdaptPreviousStepAPI(id, adaptId)
    if(response){
      dispatch(adaptStartSuccess(response))
    }
    if(callback) callback(response)
    return response;
  } catch (forgetError) {
    dispatch(adaptStartError(forgetError))
  }
};

export default adaptSlice.reducer;
